const config = {
  apiKey: "AIzaSyB-TtSf8BbJdVaeZoAWEeEbZsZjsJQ9-jI",
  authDomain: "daily-tasks-f8e04.firebaseapp.com",
  projectId: "daily-tasks-f8e04",
  storageBucket: "daily-tasks-f8e04.appspot.com",
  messagingSenderId: "646392771067",
  appId: "1:646392771067:web:a29e11cf40bc3ae9019b5e"
};

export default config;